import { useEffect } from "react";
import wooStoreApiService from "@/api/services/wooStoreApiService";
import useAppDispatch from "@/hooks/useAppDispatch";
import { handleApiError } from "@/helpers/apiErrorHelper";
import { saveCartNonce } from "@/helpers/helpers";

const useApp = () => {
  const appDispatch = useAppDispatch();

  const getCartDataAndNonce = async (signal?: AbortSignal) => {
    try {
      const response = await wooStoreApiService.cart.getCartData(signal);
      return response;
    } catch (error) {
      throw error;
    }
  };

  const initializeApp = async (signal: AbortSignal) => {
    try {
      const response = await getCartDataAndNonce(signal);
      const cartData = response.data;
      appDispatch.setFullCart(cartData);

      const nonce = response.headers?.["nonce"];
      saveCartNonce(nonce);
    } catch (error) {
      handleApiError(error, appDispatch, "初始化應用程式失敗，請重新整理頁面");
    } finally {
      if (signal?.aborted) return;
      appDispatch.setAppReady();
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    initializeApp(controller.signal);

    return () => {
      controller.abort();
    };
  }, []);
};

export default useApp;
